function isShopifyProductPathname(pathname) {
  return /\/products\/[^/]+\/?$/.test(pathname);
}

class recordRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.name = "bakerodeh_recently_viewed";
    this.recordRecentlyViewed();
  }
  config(){
    return {
      howManyToStoreInMemory: Number(this.getAttribute('data-count') || 0) + 1,
      settings: this.getAttribute('data-settings')
    };
  }
  setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) {
        var arr = c.substring(nameEQ.length,c.length);
        return arr.split(' ');
      }
    }
    return [];
  }
  recordRecentlyViewed(){ 
    try {
      var config = this.config(),
          recentlyViewed = this.getCookie(this.name);
      if (isShopifyProductPathname(window.location.pathname)) {
        var handleEl = document.querySelector('[data-product-handle]');
        if (!handleEl) return;
        var productHandle = handleEl.getAttribute('data-product-handle');
        if (!productHandle) return;
        var position = -1;
        if(recentlyViewed){
          position = recentlyViewed.indexOf(productHandle);
        }
        if (position === -1) {
          recentlyViewed.unshift(productHandle);
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        }
        else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);              
        }
        this.setCookie(this.name,recentlyViewed.join(' '),1);
      }
    } catch (e) { /* avoid breaking the page if DOM or cookies are unavailable */ }
  }
}
class recentlyViewedProducts extends recordRecentlyViewedProducts {
  constructor() {
    super();
    
    var currentproducts = this.getCookie(this.name);
    if(currentproducts.length <= 0){
            console.log(currentproducts.length)
        if(Shopify.designMode){
            this.getProducts("");
        }
        return;
    }

    if (isShopifyProductPathname(window.location.pathname)) {
      var handleEl = document.querySelector('[data-product-handle]');
      if (handleEl) {
        var productHandle = handleEl.getAttribute('data-product-handle');
        if (productHandle) {
          var index = currentproducts.indexOf(productHandle);
          if (index !== -1) currentproducts.splice(index, 1);
        }
      }
    }
    currentproducts = currentproducts.join('||');
    this.getProducts(currentproducts);
  }
  getProducts(currentproducts){
    var _this = this;
    fetch(`${window.routes.collections_url}/all?view=ajax_recently_viewed&sort_by=${currentproducts}|split|${this.config().settings}`)
      .then((response) => response.text())
      .then((responseText) => {
        var container = _this.querySelector('.recently-viewed-products-content');
        if (!container) return;
        responseText == "" ? _this.classList.add("hide"):_this.classList.remove("hide");
        container.innerHTML = responseText;
      });
  }
}

customElements.define('recently-viewed-products', recentlyViewedProducts);
!document.querySelector('recently-viewed-products') && customElements.define('recently-viewed-products-record', recordRecentlyViewedProducts);